<app-dialog
  [title]=" data.title ? data.title : 'Create New Vendor Item'"
  [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    { text: 'Create & Add', spin: spin,isDisabled: ((!selectedItems.length || vendorItemForm.invalid) && !isAddProduct) || ((productForm.invalid || vendorItemForm.invalid) && isAddProduct) || isDisable || !isValidVendor}
  ]"
  (action)="action($event)"
  (close)="action($event)"
>
<app-page-container-devider [title]="'Product'" [small]="true" [class]="'devider mt-3'"></app-page-container-devider>
  <div class="add-sku" *ngIf="!isAddProduct">
    <div class="add-sku_form" [formGroup]="form">
      <div class="input-container">
        <label for="" class="input-container_label">Search Product</label>
      <input
        type="text"
        class="input-container_input search-input"
        placeholder="Search"
        formControlName="autocomplete"
        [matAutocomplete]="auto"
        (paste)="onPaste($event)"
        *ngIf="!isSelected"
        (click)="setScroll()"
        [ngClass]="{ 'error' : (filteredProducts$)?.length == 0 && form.get('autocomplete').valid}"
      />
      <i *ngIf="!isSelected && form.get('autocomplete').valid" class="fal fa-times-circle clear" (click)="clearControl()"></i>
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" (optionSelected)="selected($event.option.value)">
        <mat-option
          *ngFor="let option of filteredProducts$"
          [value]="option"
          class="mat-option-override"
        >
          <app-item-typeahead
            [name]="option.title"
            [sku]="option.sku"
            [id]="option.name"
            [image]="option.imageUrl"
          ></app-item-typeahead>
        </mat-option>
      </mat-autocomplete>
      <app-item-typeahead
      class="item-selected"
      *ngIf="isSelected"
      [name]="selectedItems[0].title"
      [sku]="selectedItems[0].sku"
      [id]="selectedItems[0].name"
      [image]="selectedItems[0].imageUrl"
      ></app-item-typeahead>     
    </div>
      <span class="add-sku_result" *ngIf="isSelected">
        <span class="link"  (click)="clear()"><i class="fal fa-times-circle"></i><span>Clear</span></span>
      </span>      
    </div>
    <div class="add-sku_result"><span class="me-1" *ngIf="filteredProducts$?.length == 0 && form.get('autocomplete').valid">No product found</span><a draggable="false" href="javascript:void(0)" class="primary_color"  (click)="createProduct()">Create New Product</a></div>
  </div>
  <div class="top" *ngIf="isAddProduct">
    <div
      class="top_image"
      [style.backgroundImage]="
        'url(' +
        (product && product.imageUrl
          ? product.imageUrl
          : '' || 'assets/images/No_image.png') +
        ')'
      "
    ></div>
    <div class="top_form" [formGroup]="productForm">
      <div class="input-container">
        <label for="" class="input-container_label">Name*</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="name"
        />
        <div
        class="input-container_error-message"
        *ngIf="productForm.controls['name'].errors?.unique"
      >
        Item name already exists for this vendor
      </div>
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Description</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="title"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Brand</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="brand"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Model</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="model"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Color</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="color"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">UPC</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="upc"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Image URL</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="imageUrl"
          (blur)="updateImage()"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Default Location</label>
        <input
          type="text"
          class="input-container_input"
          formControlName="defaultLocation"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">L <span class="gray"> (inch)</span></label>
        <input
          type="number"
          class="input-container_input"
          formControlName="length"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">W <span class="gray"> (inch)</span></label>
        <input
          type="number"
          class="input-container_input"
          formControlName="width"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">H <span class="gray"> (inch)</span></label>
        <input
          type="number"
          class="input-container_input"
          formControlName="height"
        />
      </div>

      <div class="input-container">
        <label for="" class="input-container_label">Weight <span class="gray"> (LB)</span></label>
        <input
          type="number"
          class="input-container_input"
          formControlName="weight"
        />
      </div>
    </div>
  </div>

<app-page-container-devider [title]="'New Vendor Item'" [small]="true" [class]="'devider'"></app-page-container-devider>  
  <div class="form" [formGroup]="vendorItemForm" [ngClass]="{'disabled': selectedItems.length == 0 && !isAddProduct}">
    <div class="input-container">
      <label for="" class="input-container_label">Vendor</label>
      <input
        type="text"
        class="input-container_input"
        formControlName="vendor"
        [matAutocomplete]="auto"
        placeholder="Search"
        [ngClass]="{'error': (isDisable && (filteredOptions$ | async)?.length == 0) || (!isValidVendor) }"
      />
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" (optionSelected)="vendorSelected($event.option.value)">
        <mat-option
          *ngFor="let option of filteredOptions$ | async"
          [value]="option"
          class="mat-option-override"
        >
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </div>
    <div class="input-container">
      <label for="" class="input-container_label">Vendor Item Name</label>
      <input
        type="text"
        class="input-container_input"
        formControlName="vendorItemName"
      />
      <div
        class="input-container_error-message"
        *ngIf="form.controls['vendorItemName']?.errors?.unique"
      >
        Item name already exists for this vendor
      </div>
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Price</label>
      <div class="input-container_wrapper">
        <input
          type="number"
          class="input-container_input input-container_input--number"
          formControlName="price"
        />
        <div class="input-container_icon input-container_icon--no-background">
          $
        </div>
      </div>
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Local Stock</label>
      <input
        type="number"
        class="input-container_input"
        formControlName="localstock"
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Case Qty</label>
      <input
        type="number"
        class="input-container_input"
        formControlName="caseQty"
      />
    </div>

    <div class="input-container">
      <label for="" class="input-container_label">Case Rounding Setting</label>
      <select
        type="number"
        class="input-container_input input-container_input--select"
        formControlName="caseRoundingSetting"
      >
        <option value="up">Up</option>
        <option value="down">Down</option>
        <option value="nearest">Nearest</option>
        <option value="none">None</option>
        , , ,
      </select>
    </div>

    <div class="input-container input-container--w100">
      <label for="" class="input-container_label">Note</label>
      <input
        class="input-container_input"
        formControlName="note"
      />
    </div>
  </div>
</app-dialog>
